export const SVG_MAP_MIN_SCALE = 1;
export const SVG_MAP_STEP = 0.1;
export const SVG_MAP_ZOOM_STEP = 0.25;

/**
 * Max number of pixels that SVG map can shift by during user's mouse click or tap.
 * If SVG map shifts by more pixels then it is considered as dragging, not a click.
 */
export const SVG_MAP_CLICK_MAX_SHIFT = 10;
